export default function deepCloneBlock(emailData, childrenIds) {
  const newChildrenIds = [];

  // Falls der Block Kinder hat (in 'childrenIds')
  if (childrenIds) {
    childrenIds.forEach(childId => {
      // Neue ID für das Kind erzeugen
      const newId = `block-${Math.floor(Math.random() * 900000000000) + 1000000000000}`;
      // Das Kind kopieren
      const copiedChild = JSON.parse(JSON.stringify(emailData[childId]));
      // Falls das Kind selbst Kinder hat (rekursiv aufrufen)
      if (copiedChild.data.props.childrenIds) {
        const oldChildrenIds = copiedChild.data.props.childrenIds;  // Alte Kinder-IDs speichern
        copiedChild.data.props.childrenIds = deepCloneBlock(emailData, copiedChild.data.props.childrenIds);  // rekursiver Aufruf
        if(copiedChild.type == 'Ruleset') {
            copiedChild.data.props.rules.map(rule => {
               rule.conditionalBlock = copiedChild.data.props?.childrenIds[oldChildrenIds.indexOf(rule?.conditionalBlock)] || ''
            })
         }
      }
      if (copiedChild.data.props.columns) {
        copiedChild.data.props.columns.forEach((column, index) => {
          if (column.childrenIds) {
            copiedChild.data.props.columns[index].childrenIds = deepCloneBlock(emailData, copiedChild.data.props.columns[index].childrenIds);  // Kinder der Spalten rekursiv kopieren
          }
        });
      }    
      // Das kopierte Kind mit der neuen ID in 'emailData' speichern
      emailData[newId] = copiedChild;
      const creationDate = new Date().toLocaleString('de-DE', { timeZone: 'Europe/Berlin' });
      const name = `${emailData[childId].type}${childId}copiedAt${creationDate}`;
      emailData[newId].data.props.name = name; 
      // Neue ID des Kindes in das Array der neuen Kinder-IDs einfügen
      newChildrenIds.push(newId);
    });
  }
  return newChildrenIds;  // Rückgabe der neuen Kinder-IDs
}
